export const isSuccess = (response) => response && response.type && response.type.endsWith('_SUCCESS');

export const isError = (response) => response && response.type && response.type.endsWith('_FAIL');

export const getPayloadData = (response) => response?.payload?.data;

export const getErrorCode = (response) => response?.error?.response?.data?.errorCode;
